import React from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import pargavidoc from '../../../../assets/images/Doctorsimages/dr.pargavi.png'
import favicon from "./../../../../assets/images/favicon.ico"
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import AutoScrollImageRow from '../../AdvancedTreatmentsforHome/AutoScrollImageRow'

const PargaviDoc = () => {
  const navigate = useNavigate();
   useEffect(() => {
       document.title = "Dr. J. Pargavi | Best Homeopathy & Aesthetic Doctor in Jayanagar Bangalore";
       const metaDescription = document.querySelector("meta[name='description']");
       if (metaDescription) {
         metaDescription.setAttribute(
           "content",
           "Consult Dr. J. Pargavi (BHMS, FFAC), female homeopathy and aesthetic doctor at H-Cura Multispeciality Clinic, Jayanagar, Bangalore. Expert in homeopathy, skin care, hair fall, PCOS, infertility, acne, pigmentation, and holistic treatments near JP Nagar, Banashankari & Basavanagudi."
         );
       }
       const metaKeywords = document.querySelector("meta[name='keywords']");
     if (metaKeywords) {
  metaKeywords.setAttribute(
    "content",
    "best homeopathy doctor in Jayanagar Bangalore, female homeopathy doctor in Bangalore, cosmetic doctor in Jayanagar, facial aesthetics doctor near JP Nagar, skin doctor in Banashankari, holistic doctor in Jayanagar Bangalore, homeopathy doctor near Basavanagudi and BTM Layout, female homeopathy doctor for PCOS in Bangalore, homeopathy doctor for infertility in Bangalore, Hydrafacial treatment in Jayanagar Bangalore, chemical peel doctor in Bangalore, homeopathy doctor for hair fall in Jayanagar"
  );
}

        // Set canonical link
        const existingCanonical = document.querySelector("link[rel='canonical']");
        if (existingCanonical) {
          existingCanonical.setAttribute("href", "https://www.h-cura.com/doctors/dr-j-pargavi-homeopathy-aesthetic-doctor-jayanagar-bangalore");
        } else {
          const canonicalLink = document.createElement("link");
          canonicalLink.setAttribute("rel", "canonical");
          canonicalLink.setAttribute("href", "https://www.h-cura.com/doctors/dr-j-pargavi-homeopathy-aesthetic-doctor-jayanagar-bangalore");
          document.head.appendChild(canonicalLink);
        }
        // Set favicon
     const existingFavicon = document.querySelector("link[rel='icon']");
     if (existingFavicon) {
       existingFavicon.setAttribute("href", favicon);
     } else {
       const faviconLink = document.createElement("link");
       faviconLink.setAttribute("rel", "icon");
       faviconLink.setAttribute("type", "image/x-icon");
       faviconLink.setAttribute("href", favicon);
       document.head.appendChild(faviconLink);
     }
     }, []);


     const handleDownloadPdf = () => {
  const container = document.querySelector('.veenadoc');
  container.classList.add('veenadoc-pdf-mode');
  const originalStyles = new Map();
  const allElements = container.querySelectorAll('*');
  allElements.forEach(el => {
    originalStyles.set(el, {
      transition: el.style.transition,
      animation: el.style.animation,
      transform: el.style.transform,
      filter: el.style.filter
    });

    el.style.transition = 'none';
    el.style.animation = 'none';
    el.style.transform = 'none';
    el.style.filter = 'none';
  });
  const heroSection = container.querySelector('.veenadoc-hero-section');
  if (heroSection) {
    heroSection.style.minHeight = 'auto';
    heroSection.style.padding = '40px 0';
  }
  const images = container.querySelectorAll('img');
  images.forEach(img => {
    img.style.opacity = '1';
  });
  setTimeout(() => {
    html2canvas(container, {
      scale: 2,
      dpi: 300,
      useCORS: true,
      allowTaint: true,
      letterRendering: true,
      backgroundColor: '#ffffff',
      logging: false,
      windowWidth: container.scrollWidth,
      windowHeight: container.scrollHeight,
      scrollY: -window.scrollY,
      scrollX: -window.scrollX,
      imageTimeout: 0,
      removeContainer: false
    }).then(canvas => {
      container.classList.remove('veenadoc-pdf-mode');
      allElements.forEach(el => {
        const original = originalStyles.get(el);
        el.style.transition = original.transition;
        el.style.animation = original.animation;
        el.style.transform = original.transform;
        el.style.filter = original.filter;
      });
      if (heroSection) {
        heroSection.style.minHeight = '';
        heroSection.style.padding = '';
      }

      const imgData = canvas.toDataURL('image/jpeg', 0.95);
      const pdf = new jsPDF('p', 'mm', 'a4', true);

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const canvasWidth = canvas.width;
      const canvasHeight = canvas.height;
      const marginLeft = 10; 
      const marginRight = 10;
      const availableWidth = pdfWidth - marginLeft - marginRight;
      const scaleFactor = availableWidth / canvasWidth;
      const imgWidth = canvasWidth * scaleFactor;
      const imgHeight = canvasHeight * scaleFactor;
      const pages = Math.ceil(imgHeight / pdfHeight);

      for (let i = 0; i < pages; i++) {
        if (i > 0) {
          pdf.addPage();
        }
        pdf.addImage(imgData, 'JPEG', marginLeft, -i * pdfHeight, imgWidth, imgHeight, undefined, 'FAST');
      }

      pdf.save('Dr.Pargavi_Profile.pdf');
    }).catch(error => {
      console.error('Error generating PDF:', error);
      alert('Failed to generate PDF. Please try again.');
      container.classList.remove('veenadoc-pdf-mode');
      if (heroSection) {
        heroSection.style.minHeight = '';
        heroSection.style.padding = '';
      }

      allElements.forEach(el => {
        const original = originalStyles.get(el);
        if (original) {
          el.style.transition = original.transition;
          el.style.animation = original.animation;
          el.style.transform = original.transform;
          el.style.filter = original.filter;
        }
      });
    });
  }, 100);
};

  return (
    <>
      <div className="veenadoc">
        {/* Hero Section */}
        <div className="veenadoc-hero-section">
          <div className="veenadoc-hero-background">
            <div className="veenadoc-wave-pattern">
              <svg viewBox="0 0 1200 320" className="veenadoc-wave-svg" preserveAspectRatio="none">
                <path d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="rgba(46, 125, 50, 0.1)"></path>
              </svg>
            </div>
            <div className="veenadoc-floating-shapes">
              <div className="veenadoc-shape veenadoc-shape-1"></div>
              <div className="veenadoc-shape veenadoc-shape-2"></div>
              <div className="veenadoc-shape veenadoc-shape-3"></div>
              <div className="veenadoc-shape veenadoc-shape-4"></div>
            </div>
          </div>

          <div className="veenadoc-container">
            <div className="veenadoc-hero-content">
              <div className="veenadoc-hero-left">
                <h1 className="veenadoc-hero-title">
                  <span className="veenadoc-title-highlight">Dr. J. Pargavi</span>
                  <span className="veenadoc-title-credentials">(BHMS, FFAC)</span>
                  <span className="veenadoc-title-location">Jayanagar, Bangalore</span>
                </h1>

                <div className="veenadoc-hero-description">
                  <p>
                    Skilled and compassionate Consultant in Homeopathy and Aesthetics at H-Cura Multispeciality Clinic, 
                    Jayanagar, Bangalore. Recognized as the best homeopathy doctor in Jayanagar Bangalore and a trusted 
                     homeopathy doctor who uniquely blends classical homeopathy with modern cosmetology treatments 
                    for comprehensive healthcare solutions.
                  </p>
                </div>

                <div className="veenadoc-hero-actions">
                  <button
              className="veenadoc-btn-primary-gradient"
              onClick={() => navigate('/bookconsultation')}
            >
              <span className="veenadoc-btn-icon">📞</span>
              <span>Book Consultation</span>
              <div className="veenadoc-btn-shine"></div>
            </button>
                </div>
              </div>

              <div className="veenadoc-hero-right">
                <div className="veenadoc-doctor-showcase">
                  <div className="veenadoc-doctor-frame">
                    <div className="veenadoc-frame-glow"></div>
                    <div className="veenadoc-image-container">
                      <img src={pargavidoc} alt="Dr. J. Pargavi – Homeopathy & Aesthetic Doctor in Jayanagar, Bangalore" className="veenadoc-doctor-image" title='Dr. J. Pargavi | Best Female Homeopathy Doctor in Jayanagar Bangalore' />
                      <div className="veenadoc-image-overlay"></div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>

        {/* Article Content */}
        <div className="veenadoc-article-section">
          <div className="veenadoc-container">
            <div className="veenadoc-article-layout">

              {/* Main Article Content */}
              <div className="veenadoc-article-main">

                {/* Introduction */}
                <div className="veenadoc-article-block">
                  <h2>About Dr. J. Pargavi</h2>
                  <p>
                    Dr. J. Pargavi (BHMS, FFAC) is a skilled and compassionate Consultant in Homeopathy and Aesthetics at 
                    H-Cura Multispeciality Clinic, Jayanagar, Bangalore. Patients searching for the best homeopathy doctor 
                    in Jayanagar Bangalore, a  homeopathy doctor near JP Nagar and Banashankari, or a cosmetic and 
                    aesthetic doctor in Bangalore often choose her because of her unique ability to blend classical homeopathy 
                    with modern cosmetology treatments.
                  </p>
                  <p>
                    She completed her Bachelor of Homeopathic Medicine and Surgery (BHMS) at Vinayaka Mission Homoeopathic 
                    Medical College and Hospital and later pursued a Fellowship in Facial Aesthetics and Cosmetology 
                    (FFAC) to expand her expertise in skin, hair, and cosmetic care.
                  </p>
                </div>

                {/* Clinical Journey */}
                <div className="veenadoc-article-block">
                  <h2>Clinical Journey & Professional Expertise</h2>
                  <p>
                    With over 2 years of experience in homeopathy and aesthetic medicine, Dr. Pargavi has treated patients 
                    with a wide range of conditions. She is skilled in case-taking, diagnosis, and repertorization, and is 
                    known for treating every patient as a unique individual with a personalized approach.
                  </p>
                  <p>
                    Her additional training has made her proficient in handling advanced aesthetic treatments such as 
                    Hydrafacial, chemical peeling, injectable techniques, laser therapies and haircare. This blend of homeopathy and aesthetics allows her to provide both medical and cosmetic 
                    solutions for her patients.
                  </p>
                </div>

               
                     <div className="veenadoc-sidebar-card">
                  <h3>Quick Information</h3>
                  <div className="veenadoc-info-grid">
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Qualification:</span>
                      <span className="veenadoc-info-value">BHMS, FFAC</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Experience:</span>
                      <span className="veenadoc-info-value">2+ Years</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Specialization:</span>
                      <span className="veenadoc-info-value">Homeopathy & Aesthetics</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Location:</span>
                      <span className="veenadoc-info-value">Jayanagar, Bangalore</span>
                    </div>
                  </div>
                </div>

             <div className="veenadoc-article-block">
                  <h2>Specialized in HairCare Solutions</h2>
                  <p>
                    Dr. Pargavi has gained recognition as a haircare doctor in Bangalore specializing in hair fall, dandruff, scalp conditions, hair thinning, premature greying, alopecia, and hair regrowth treatments. She also provides advanced hair therapies such as PRP (Platelet-Rich Plasma), GFC (Growth Factor Concentrate), Mesotherapy, Laser Hair reduction and qr678 to ensure effective and long-lasting results.
                   

                  </p>
                  <p>
                    Her expertise  ensures  that patients not only regain healthy hair and skin  but also confidence and peace of mind.
                  </p>
                </div>


                {/* Expertise in Chronic Conditions */}
                <div className="veenadoc-article-block">
                  <h2>Expertise in Chronic & Acute Conditions</h2>
                  <p>
                    Her patients often consult her for both acute and chronic illness, ranging from respiratory problems, 
                    arthritis, thyroid disorders, migraine, skin diseases, hair fall and lifestyle-related conditions. 
                    For those searching for a holistic doctor in Jayanagar Bangalore, her integrative style of treatment makes 
                    her a highly preferred choice.
                  </p>
                  <p>
                    She takes time to understand each patient's unique physical, mental, and emotional symptoms before 
                    prescribing personalized remedies. This comprehensive approach ensures lasting improvement and sets her 
                    apart from other practitioners.
                  </p>
                </div>

                {/* Aesthetic Medicine */}
                <div className="veenadoc-article-block">
                  <h2>Leading Aesthetic Doctor in Jayanagar</h2>
                  <p>
                    At H-Cura Jayanagar, she offers specialized skin and aesthetics treatments for patients dealing with acne, 
                    pigmentation, psoriasis, eczema, dermatitis, wrinkles, and anti-aging concerns. Many people searching online 
                    for a cosmetic doctor in Jayanagar Bangalore, a facial aesthetics doctor near JP Nagar, or a skin doctor 
                    in Banashankari find their way to her clinic.
                  </p>
                  <p>
                    She has successfully provided Hydrafacial treatments for glowing skin, chemical peels for acne scars and 
                    pigmentation, injectable therapies for wrinkle reduction, and laser treatments for long-term skin rejuvenation. 
                   
                  </p>
                </div>

                {/* Anti-Aging Solutions */}
                <div className="veenadoc-article-block">
                  <h2>Advanced Aesthetic Treatments</h2>
                  <p>
                    Her expertise extends to advanced aesthetic procedures including Hydrafacial treatment in Jayanagar Bangalore, 
                    chemical peels, and laser therapies. As patients search for aesthetic treatments in Jayanagar Bangalore, 
                    they often discover her reputation for offering safe, effective, and result-oriented cosmetic solutions.
                  </p>
                  <p>
                    She believes that external beauty is best preserved when internal health is maintained, which is why her 
                    aesthetic treatments are always supported by holistic health guidance and homeopathic care.
                  </p>
                </div>

                {/* Hair Care Expertise */}
                <div className="veenadoc-article-block">
                  <h2>Comprehensive Hair Care Solutions</h2>
                  <p>
                    She is also recognized as a homeopathy doctor for hair fall in Bangalore, offering natural and holistic 
                    treatments for scalp infections, dandruff, premature greying, and hair thinning.
                she provides a unique approach that combines homeopathy remedies with advanced haircare.
                  </p>
                  <p>
                    By focusing on the underlying cause—whether it is stress, nutrition, or hormonal imbalance—she ensures 
                    long-lasting results. This approach has made her one of the most recommended homeopathy doctors for hair 
                    regrowth in Jayanagar Bangalore.
                  </p>
                </div>

                {/* Women's Health */}
                <div className="veenadoc-article-block">
                  <h2>Women's Health Specialist</h2>
                  <p>
                    For women's health, Dr. Pargavi has become a trusted  homeopathy doctor in Jayanagar Bangalore. 
                    She treats conditions like PCOS, infertility, hormonal imbalances, and menopause-related issues with 
                    gentle, effective, and side-effect-free remedies.
                  </p>
                  <p>
                    Patients searching for a female doctor for PCOS in Bangalore or a homeopathy doctor for infertility near 
                    JP Nagar often consult her for natural alternatives that improve overall health and restore hormonal balance.
                  </p>
                </div>

                {/* Dual Expertise */}
                <div className="veenadoc-article-block">
                  <h2>What Makes Dr. Pargavi Unique</h2>
                  <p>
                    What makes Dr. Pargavi unique is her dual expertise in homeopathy and aesthetics. While many doctors 
                    specialize in only one field, she integrates both seamlessly. This dual specialization ensures that her 
                    patients don't just receive cosmetic improvements but also achieve long-term health benefits.
                  </p>
                  <p>
                    Whether someone is searching for the best  homeopathy doctor in Jayanagar Bangalore, a cosmetic 
                    doctor near JP Nagar, or a holistic doctor in Banashankari, Dr. Pargavi's profile appears as a reliable 
                    choice because of her results-driven yet patient-friendly approach.
                  </p>
                </div>

                {/* Online Presence & Patient Queries */}
                <div className="veenadoc-article-block">
                  <h2>Meeting Patient Needs in Bangalore</h2>
                  <p>
                    In Bangalore, patients increasingly search for safe, natural, and non-invasive healthcare alternatives. 
                    Her expertise aligns perfectly with common search queries such as:
                  </p>
                  <ul className="veenadoc-search-queries-list">
                    <li>Best homeopathy doctor in Jayanagar Bangalore</li>
                    <li>Cosmetic doctor near JP Nagar</li>
                    <li>Homeopathy doctor for acne and pigmentation in Banashankari</li>
                    <li> doctor for skin and hair in Basavanagudi</li>
                    <li>Holistic doctor near me in Bangalore</li>
                    <li>Facial aesthetics doctor in Jayanagar</li>
                  </ul>
                  <p>
                    Her ability to combine classical homeopathy with modern aesthetic treatments gives her a unique advantage 
                    in addressing both health and appearance-related concerns.
                  </p>
                </div>

                {/* Patient Testimonials */}
                <div className="veenadoc-article-block">
                  <h2>Patient Experience & Reviews</h2>
                  <p>
                    Patients who consult Dr. Pargavi appreciate her compassionate nature, thorough case-taking, and personalized 
                    treatment approach. Many reviews describe her as professional, knowledgeable, and highly effective in 
                    providing treatments that deliver visible and long-lasting results.
                  </p>
                  <p>
                    Her strong reputation for combining medical knowledge with personal care has made her one of the most trusted 
                    names in homeopathy and aesthetics at H-Cura Multispeciality Clinic Jayanagar.
                  </p>
                </div>

                {/* Conclusion */}
                <div className="veenadoc-article-block veenadoc-conclusion-block">
                  <h2>Choose Dr. J. Pargavi for Holistic Healthcare</h2>
                  <p>
                    Choosing Dr. J. Pargavi means selecting a doctor who is committed to your complete health and well-being. 
                    She provides the assurance of safe treatments, the expertise of modern aesthetic science, and the compassion 
                    of a holistic healer.
                  </p>
                  <p>
                    For anyone searching for the best homeopathy and aesthetic doctor in Jayanagar Bangalore, or specifically 
                    looking for a trusted  homeopathy doctor for skin, hair, PCOS, and infertility treatments, Dr. Pargavi 
                    is the doctor who brings together trust, expertise, and results.
                  </p>
                  <p className="veenadoc-mission-statement">
                    <strong>Her mission:</strong> To provide holistic and aesthetic treatments that are safe, natural, and 
                    effective, focusing not just on curing disease but also on enhancing overall lifestyle, confidence, and wellness.
                  </p>
                </div>

              </div>

              {/* Sidebar */}
              <div className="veenadoc-article-sidebar">

                {/* Philosophy of Care */}
                <div className="veenadoc-article-block veenadoc-philosophy-block">
                  <div className="veenadoc-philosophy-quote">
                    <div className="veenadoc-quote-icon">💫</div>
                    <blockquote>
                      "I treat every patient as a unique individual with physical, mental, and emotional symptoms"
                    </blockquote>
                    <p className="veenadoc-quote-attribution">— Dr. J. Pargavi's Philosophy of Care</p>
                  </div>
                  <p>
                    Her treatment philosophy reflects her belief in holistic care, focusing on both acute and chronic conditions 
                    with the aim of complete cure. This patient-first mindset, combined with her compassionate nature, has made 
                    her one of the most recommended  homeopathy doctors in Jayanagar, Bangalore.
                  </p>
                </div>

                {/* Locations */}
                <div className="veenadoc-sidebar-card">
                  <h3>Practice Location</h3>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">📍</div>
                    <div className="veenadoc-location-details">
                      <h4>H-Cura Multispeciality Clinic</h4>
                      <p>Jayanagar, Bangalore</p>
                    </div>
                  </div>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">🏥</div>
                    <div className="veenadoc-location-details">
                      <h4>Serving Areas</h4>
                      <p>JP Nagar, Banashankari, Basavanagudi, BTM Layout</p>
                    </div>
                  </div>
                </div>

                {/* Contact CTA */}
                <div className="veenadoc-sidebar-card veenadoc-cta-card">
                  <h3>Book Your Consultation</h3>
                  <p>Experience holistic healthcare with Dr. Pargavi's personalized approach to homeopathy and aesthetics.</p>
                 <button
                  className="veenadoc-sidebar-btn-primary"
                  onClick={() => window.location.href = 'tel:+919964688333'}
                >
                  <span>📞</span>
                  <span>Schedule Appointment</span>
                </button>
                <button
                  className="veenadoc-sidebar-btn-secondary"
                  onClick={() => window.location.href = 'tel:+919964688333'}
                >
                  <span>💬</span>
                  <span>Get Free Assessment</span>
                </button>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>


       <AutoScrollImageRow/>

       <div className="bangloregfcblog-download-section">
            <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
              Download This Doctor profile as PDF
            </button>
          </div>
    </>
  )
}

export default PargaviDoc
